import dispatcher from "../dispatcher"
import { setTimeout } from "timers"
import * as api from "../api"
import { ETimecardSequenceActionType, IPunchException, ITimecardSequenceWarningData } from "../models"
import AppStateStore from "../stores/AppStateStore"
import strings from "../localization/strings"

export function loadBiometricExceptionDetails(recordId) {
    setTimeout(() => {
        dispatcher.dispatch({
            type: "FETCHING_BIOMETRIC_EXCEPTION",
            recordId: recordId
        })
        api.getPunchBiometricExceptionDetail(recordId).then(function (response) {
            recieveBiometricRecordDetail(response.data)
        })
    }, 0)
}

export function recieveBiometricRecordDetail(biometricException) {
    dispatcher.dispatch({
        type: "RECEIVE_BIOMETRIC_EXCEPTION",
        biometricException: biometricException
    })
}

export function loadLocationExceptionDetails(recordId) {
    setTimeout(() => {
        dispatcher.dispatch({
            type: "FETCHING_LOCATION_EXCEPTION",
            recordId: recordId
        })
        api.getPunchLocationExceptionDetail(recordId).then(function (response) {
            recieveLocationRecordDetail(response.data)
        })
    }, 0)
}

export function recieveLocationRecordDetail(locationException) {
    dispatcher.dispatch({
        type: "RECEIVE_LOCATION_EXCEPTION",
        locationException: locationException
    })
}

export async function reviewLocException(punchId: string, locationException: IPunchException, cb: () => void) {
    const response = await api.updatePunchLocationException(punchId, locationException)
    const result: ITimecardSequenceWarningData = response.data
    result.Type === ETimecardSequenceActionType.ExceptionReviewedAlready ?
        AppStateStore.setAlertDialogContent({
            title: strings.Cannot_Review_Location_Exception,
            content: strings.Exception_was_reviewed_already
        }) :
        result.WarningItems && result.WarningItems.length > 0 ?
            AppStateStore.setTimecardSequenceWarningDialogContent({
                warningData: result,
                handleRetry: () => reviewLocException(punchId, locationException, cb)
            }) :
            cb()
}

export async function reviewBioException(punchId: string, bioException: IPunchException, cb: () => void) {
    const response = await api.updatePunchBiometricException(punchId, bioException)
    const result: ITimecardSequenceWarningData = response.data
    result.Type === ETimecardSequenceActionType.ExceptionReviewedAlready ?
        AppStateStore.setAlertDialogContent({
            title: strings.Cannot_Review_Biometric_Exception,
            content: strings.Exception_was_reviewed_already
        }) :
        result.WarningItems && result.WarningItems.length > 0 ?
            AppStateStore.setTimecardSequenceWarningDialogContent({
                warningData: result,
                handleRetry: () => reviewBioException(punchId, bioException, cb)
            }) :
            cb()
}
